<template>
  <a-modal
    class="company-modal-wrapper"
    width="850px"
    :mask-closable="false"
    :visible="visible"
    title="关联推广"
    @ok="$emit('onCancel')"
    @cancel="$emit('onCancel')"
  >
    <a-table
      :columns="columns"
      :data-source="data"
      size="middle"
      :row-key="record => record.id"
      :pagination="false"
    >
      <template
        slot="time"
        slot-scope="text, record"
      >
        {{ `${$Moment(record.task_start_time).format('YYYY-MM-DD')}~${$Moment(record.task_end_time).format('YYYY-MM-DD')}` }}
      </template>
      <template
        slot="finish_time"
        slot-scope="text, record"
      >
        {{ record.finish_time===0?'0':$Format(record.finish_time) }}
      </template>
    </a-table>
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible'],
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
        },
        {
          title: '任务名称',
          dataIndex: 'task_name',
          width: 100,
        },
        {
          title: '推广人',
          dataIndex: 'promoter_name',
        },
        {
          title: '任务类型',
          dataIndex: 'task_type_name',
        },
        {
          title: '任务周期',
          dataIndex: 'time',
          scopedSlots: { customRender: 'time' },

        },
        {
          title: '阅读次数',
          dataIndex: 'read_hits',
        },
        {
          title: '阅读时间',
          dataIndex: 'read_time',
        },
        {
          title: '完成时间',
          dataIndex: 'finish_time',
          scopedSlots: { customRender: 'finish_time' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          customRender: (text, record, index)=>{
            if(record.status===1){
              return '已完成';
            }
            if(record.status===0){
              return '未完成';
            }
          },
        },
      ],
    };
  },
  mounted() {},
  methods: {

  },
};
</script>
<style lang="scss" scoped>
.company-modal-wrapper{
.ant-table-wrapper{
  height: 600px;
    overflow-y: scroll;
}
 }
</style>